import { useSubscribe } from "@/src/lib/actions";
import { useState } from "react";

export function usePageChange() {
  const [page, setPage] = useState(1);

  useSubscribe<number>("bkg:page", setPage);

  return page;
}

export function usePageSize() {
  const [pageSize, setPageSize] = useState(10);

  useSubscribe<number>("bkg:page-size", setPageSize);

  return pageSize;
}

export function useSearch() {
  const [search, setSearch] = useState("");

  useSubscribe<string>("bkg:search", setSearch);

  return search;
}

export function useSorting() {
  const [sorting, setSorting] = useState("DESC");

  useSubscribe<string>("bkg:sorting", setSorting);

  return sorting;
}
